export default __webpack_public_path__ + "static/media/active-stat-icon.135485ee.svg";